import React, { FC, useEffect } from "react"
import { Form, Modal, Switch } from "antd"
import { observer } from "mobx-react"

import { useStore } from "stores/utils/use-store"
import { SubmitCancelButtons } from "components"

export const GameplayBoostTester: FC<{
  visible: boolean;
  onClose: () => void;
}> = observer(({ visible, onClose }) => {
  const [form] = Form.useForm<{ enabled: boolean }>()

  const { dataStore: { accountDetailsStore } } = useStore()

  const currentEnabled = !!accountDetailsStore.account.gameplayBoostTester

  // Reflect the account's current flag every time the modal opens so a no-op
  // submit can't silently overwrite a true state with false.
  useEffect(() => {
    if (visible) form.setFieldsValue({ enabled: currentEnabled })
  }, [visible, currentEnabled, form])

  const onFinishHandler = async(e: { enabled: boolean }) => {
    accountDetailsStore.funcAfterSuccess = async() => {
      onClose()
      form.resetFields()
      await accountDetailsStore.getAccountDetails(accountDetailsStore.id)
    }
    await accountDetailsStore.setGameplayBoostTester(e.enabled)
  }

  return (
    <Modal visible={visible} title="Gameplay Boost Tester" footer={null} onCancel={() => onClose()}>
      <Form form={form} onFinish={onFinishHandler}>
        <div style={{ marginBottom: "10px" }}>
          When enabled, this account bypasses the Gameplay Boost country whitelist so QA can test
          from non-supported regions. Game whitelist and opt-in still apply.
        </div>
        <Form.Item label="Tester bypass" name="enabled" valuePropName="checked" initialValue={currentEnabled}>
          <Switch />
        </Form.Item>
        <SubmitCancelButtons onClose={onClose} isLoading={accountDetailsStore.isLoading} />
      </Form>
    </Modal>
  )
})
